var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.componentByPartner,_vm._b({tag:"Component"},'Component',{partner: _vm.partner, currentCountry: _vm.currentCountry},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }